module.exports = __webpack_public_path__ + "static/media/mp.4ce63fc0.svg";